<template>
  <div id="main-view">
    <div id="container">
      <router-view name="header"></router-view>
      <router-view></router-view>
      <router-view name="footer"></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'app',
  };

</script>

<style src="style/main.css"></style>
<style src="style/brochure.css"></style>



// WEBPACK FOOTER //
// App.vue?0bba792f